import Default from "./layout/Default";
import Logo from '../components/common/Logo/Logo';
import DefaultLogo from "./layout/DefaultLogo";
const Aup = () => {
  return (
    <DefaultLogo>
      <div style={{ padding: "10px 4px" }}>
        <h2 className="mb-2" style={{textAlign: "center"}}>
          Acceptable Use Policy for the VirtuWard Services
        </h2>
        <div style={{ marginTop: "20px" }}>
          <h6 style={{marginBottom:'28px'}}>Effective Date: June 2023</h6>
          <p style={{ textAlign: "justify" }}>
            Provide Digital as part of Provide Enterprises Limited <b>(“Provide”, “us”, “our” or “we”)</b> have
            adopted this Acceptable Use Policy (“AUP”) to govern the use of
            their digital product – VirtuWard web-based software (the main
            domain of <a href="https://virtuward.com" target="_blank"> https://virtuward.com</a> and its sub-domains, collectively
            known as the <b>“VirtuWard Application”</b>) by the employees or
            representatives <b>(“User”, “you”, “your”)</b> of their customers
            organisation <b>(“employer”)</b>. We are registered in England and Wales
            under company number 12377709 and have our registered office at 900,
            the Crescent, Colchester Business Park, Colchester, England C04 9YQ.
            We offer a variety of content and services, including software,
            through the VirtuWard Application (each such application together
            with any applicable documentation thereto, and programming and user
            interfaces therefor, a <b>“Platform”</b>), collectively the <b>“Services”</b>,
            which your employer has tailored to its own specifications.
          </p>
          <p style={{ textAlign: "justify" }}>
            You have been asked to create a VirtuWard account by your employer
            and this acceptable use policy (together with the documents referred
            to in this) <b>(“AUP”)</b> apply and govern your use of the Services.
            Please read the AUP carefully before you start to use the Services.
          </p>
          <p style={{ textAlign: "justify" }}>
            Services provided by us may only be used for lawful purposes. You
            agree to comply with all applicable laws, rules, and regulations in
            connection with your use of the services. Any material or conduct
            that in our judgment violates this policy in any manner may result
            in suspension or termination of the services or removal of user’s
            account with or without notice.
          </p>
          <h6 style={{ margin: "10px 0px",fontWeight:'700' }}>Prohibited use</h6>
          <p style={{ textAlign: "justify" }}>
            You may not use the services to publish content or engage in
            activity that is illegal under applicable law, that is harmful to
            others, or that would subject us to liability, including, without
            limitation, in connection with any of the following, each of which
            is prohibited under this AUP:
          </p>
          <ul>
            <li>Phishing or engaging in identity theft</li>
            <li>
              Distributing computer viruses, worms, Trojan horses, or other
              malicious code
            </li>
            <li>
              Distributing pornography or adult related content or offering any
              escort services
            </li>
            <li>Promoting or facilitating violence or terrorist activities</li>
            <li>
              Infringing the intellectual property or other proprietary rights
              of others
            </li>
          </ul>
          <h6 style={{ margin: "10px 0px",fontWeight:'700' }}>Enforcement</h6>
          <p style={{ textAlign: "justify" }}>
            Your services may be suspended or terminated with or without notice
            upon any violation of this policy. Any violations may result in the
            immediate suspension or termination of your account.
          </p>
          <h6 style={{ margin: "10px 0px",fontWeight:'700' }}>Reporting violations</h6>
          <p style={{ textAlign: "justify" }}>
            To report a violation of this policy, please contact us at
            info@providedigital.com.
          </p>
          <p style={{ textAlign: "justify" }}>
            We reserve the right to change this policy at any given time, of
            which you will be promptly updated. If you want to make sure that
            you are up to date with the latest changes, we advise you to
            frequently visit this page.
          </p>
        </div>
      </div>
    </DefaultLogo>
  );
};

export default Aup;
